import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { LINKS } from "@/lib/constants";

const FAQS = [
  {
    q: "How is the SHYFT Coalition™ App billed?",
    a: "The app operates on a recurring monthly subscription processed through Shopify Payments. Billing renews automatically each month against the payment method used at signup. Receipts are issued by Shopify on every renewal cycle.",
  },
  {
    q: "Can I cancel my app subscription inside the app?",
    a: "No. In-app cancellation is intentionally disabled to keep the vault perimeter clean. To cancel, email support@shyftcoalition.com with the subject line 'Cancellation Request' and our concierge will process it within one business day.",
  },
  {
    q: "What does the 1-Year TradingView indicator license include?",
    a: "A single fixed-term, 365-day standalone access pass to the SHYFT ORB Breakout Hunter. Each Indicator added to the suite requires its own license. It does not auto-renew. After 365 days, access expires and a new license must be acquired to continue.",
  },
  {
    q: "How does TradingView access get delivered after I purchase?",
    a: "At checkout you must input your exact TradingView Username (case-sensitive) and email. After purchase you are redirected to our Success Hub. Our system then injects the SHYFT ORB script directly into your TradingView profile within 24 hours, accessible under Indicators → Invite-Only Scripts.",
  },
  {
    q: "How does community onboarding work?",
    a: "The 'Join Our Community' button routes you straight to our Mighty Networks hub with auto-join enabled. Once inside, complete your profile, and the Welcome Center will provide a Checklist to help onboard you.",
  },
  {
    q: "How do I reach support?",
    a: "All operational, billing, license, and onboarding inquiries route through a single contact: support@shyftcoalition.com. Average response time is under 24 hours.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-16 md:py-24"
    >
      <div className="max-w-5xl mx-auto px-6">
        <div className="max-w-2xl reveal">
          <div className="eyebrow !text-[#6fb3ff]">Institutional FAQ</div>
          <h2 className="font-serif-display mt-4 text-3xl md:text-4xl lg:text-[2.5rem] leading-[1.1] text-white">
            The protocol,
            <br />
            <span className="italic text-gradient-gold">in plain ink.</span>
          </h2>
        </div>

        <Accordion
          type="single"
          collapsible
          className="mt-12"
          data-testid="faq-accordion"
        >
          {FAQS.map((item, idx) => (
            <AccordionItem
              key={idx}
              value={`item-${idx}`}
              data-testid={`faq-item-${idx}`}
              className="border-b border-[rgba(201,162,91,0.18)] !border-t-0"
            >
              <AccordionTrigger className="text-left hover:no-underline py-5 group">
                <span className="flex items-center gap-5">
                  <span className="font-serif-display text-lg md:text-xl text-bronze w-9 shrink-0">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                  <span className="font-serif-display text-lg md:text-xl text-white group-hover:text-[#e7c98a] transition-colors">
                    {item.q}
                  </span>
                </span>
              </AccordionTrigger>
              <AccordionContent className="text-[#b8b3aa] text-base md:text-[17px] leading-relaxed pl-[3.75rem] pb-7">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-14 reveal flex flex-wrap items-center justify-between gap-4 rounded-full border border-[rgba(201,162,91,0.25)] bg-[#14110e]/60 backdrop-blur px-6 py-4">
          <span className="text-[#b8b3aa] text-sm md:text-base">
            Need a human? Reach the concierge directly.
          </span>
          <a
            href={`mailto:${LINKS.supportEmail}`}
            data-testid="faq-support-email"
            className="btn-outline-gold !py-2.5 !px-5 text-sm"
          >
            {LINKS.supportEmail}
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
